// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"2d82be13","460":"a683a2c4","504":"6d393ab0","692":"996007f1","868":"945ea43d","918":"cdeaac69"}[chunkId] + ".chunk.css";
};